import {
    collection,
    doc,
    documentId,
    orderBy,
    query,
    runTransaction,
    startAt,
    where
} from "firebase/firestore";
import { DateTime } from "luxon";
import db from "./firebase";


const queues = collection(db, "queues");

const getAll = () => queues;
const getOfHour = (timestamp) => collection(db, "queues", timestamp, "users");


const getCountOfHour = (timestamp) => doc(db, "queueCounts", timestamp);

const getCountAfterHour = (timestamp) => query(
  collection(db, "queueCounts"),
  orderBy(documentId()),
  where(documentId(), ">=", timestamp,),
  where(documentId(), "<", DateTime.local().endOf('day').valueOf().toString())
)
const getAllDayQueues = (timestamp) => {
  // console.log('timestamp', timestamp);
  return collection(db, "queueCounts", orderBy(documentId()), startAt(timestamp))
}

const createQueue = async (data) => {
  const { timestamp, user } = data
  console.log('timestamp',timestamp);
  console.log('user',user);

  try {
    await runTransaction(db, async (transaction) => {
      const countDocRef = doc(db, "queueCounts", timestamp)

      const count = await transaction.get(countDocRef);

      transaction.set(doc(db, "queues", timestamp, "users", user.id), user)
      if (count.exists && count.data()) {
        transaction.update(countDocRef, {
          count: Number(count.data().count) + 1
        })
      } else {
        transaction.set(countDocRef, {
          count: 1
        })
      }
      
    });
    console.log("Transaction successfully committed!");
  } catch (e) {
    console.log("Transaction failed: ", e);
  } 
};

const create = (data) => queues.add(data);

const update = (id, value) => queues.doc(id).update(value);

const remove = (id) => queues.doc(id).delete();

const QueuesService = {
  getAll,
  getOfHour,
  getCountAfterHour,
  getAllDayQueues,
  getCountOfHour,
  create,
  createQueue,
  update,
  remove
};

export default QueuesService;